import React, { FunctionComponent, useState, useRef } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import { deleteFAQAdmin, fetchFAQ, fetchFAQAdmin } from "../../Services/resources";
import { deleteFAQ } from "../../Services/resources";
import styles from "./FAQPanel.module.css";
import Lottie from "react-lottie";
import noData from "../../Assets/animations/no-data.json";
import { themeColors } from "../../Components/theme";
import topBarStyles from "../../Components/TopBar/TopBar.module.css";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import PreviewVideo from "../FAQPanel/VideoPreview";
import { useMediaQuery } from "@material-ui/core";
import { BsPlus } from "react-icons/bs";
import { BiImport, BiExport } from "react-icons/bi";
import "../../theme-vars.css";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import StyledCancelButton from "../../Components/Buttons/StyledCancelButton";

type props = { history: any; user: any, theme: any };
const FAQPanelReplicate: FunctionComponent<props> = ({ history, user, theme }) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const csvLink: any = useRef();
  const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const [faqListArr, setfaqListArr] = useState<any[]>([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.8);
  const dispatcher = useDispatch();

  const handleResize = () => {
    setMaxHeight(window.innerHeight * 0.8);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    fetchFAQAdmin((data) => setfaqList(data));
  }, []);

  const toggleAccordion = (id: string) => {
    if (id === expandedId) {
      setExpandedId(null);
    } else {
      setExpandedId(id);
    }
  };

  const handleDelete = (deleteData: any) => {
    let faqId = deleteData;
    const filterData = faqList?.filter((list: any) => list.id != faqId?.id)
    deleteFAQAdmin(
      filterData,
      dispatcher,
      history,
    );
  }
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: noData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const headers = [
    { label: "S.No", key: "serialNumber" },
    { label: "Question", key: "question" },
    { label: "Answer", key: "answer" }
  ];

  useEffect(() => {
    let faqListArr: any[] = [];
    faqList?.map((list: any) => {
      faqListArr.push({ "serialNumber": list.serialNumber, "question": list.question, "answer": list.answer })
    })
    setfaqListArr(faqListArr);
  }, [faqList]);

  const handleVideoUrl = (event: any, item: any) => {
    event.preventDefault();
    if (item) {
      window.open(item, '_blank');
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "3%" }}>
      {faqList === undefined && <Loading />}
      <div
        className="container-fluid p-4 d-flex flex-column gap-4"
      >
        <div
          className="d-flex justify-content-between"
        >
        </div>
          <div
          className="d-flex flex-column gap-4"
          style={{ ...containerStyles, maxHeight: `${maxHeight}px`, overflowX: "hidden", overflowY: "scroll", paddingBottom: isMobile ? "12%" : "5%" }}>
          {faqList && faqList.length > 0 ? (
            faqList?.map((item, index) => (
              <div
                className="card p-4 shadow rounded"
                style={cardContainerStyles}
                key={index}>
                <div className={styles.headerContainer}>
                  <h6 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }} className={styles.heading}>{`Question : ${item.serialNumber}. ${item.question}`}</h6>
                  <button className={styles.accordionButton} onClick={() => toggleAccordion(item.id)}>
                    {expandedId === item.id ? <i className='fas fa-chevron-up' /> : <i className='fas fa-chevron-down' />}
                  </button>
                </div>
                <div className={styles.line}></div>
                <p style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-small)" }}>{item.answer}</p>
                {expandedId === item.id &&
                  <>
                    {item?.videoUrl === "" || item?.videoUrl === undefined ? <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)",
                      fontWeight: '500'
                    }}>Video not available</div> : <>
                      <PreviewVideo source={item.videoUrl} />
                    </>}
                  </>
                }
              </div>
            ))
          ) : (
            <div>
              <Lottie options={defaultOptions} height={300} width={300} />
              <h5 className="text-center">No FAQ Available</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(FAQPanelReplicate);